import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseService } from '../../core/controllers/base.service';
import { VasState } from '../../vas/store/store-type';

export interface Dimensions {
    height: number;
    width: number;
}

interface ThumbnailerResponse {
    location: string;
    message: string;
    status: number;
}

@Injectable()
export class RemoteThumbnailService extends BaseService {

    constructor(
        protected thumbnailerUrl: string,
        protected http: Http,
        protected store: Store<VasState>
    ) {
        super();
    }

    getThumbnailUrl(
        accountId: string,
        fileId: string,
        dims: Dimensions
    ): Observable<string> {
        return this.getUrl(accountId, fileId, dims)
            .take(1)
            .concatMap(url => this.http.get(url))
            .map(response => response.json())
            .map((result: ThumbnailerResponse) => result.location);
    }

    protected getUrl(
        accountId: string,
        fileId: string,
        dims: Dimensions
    ): Observable<string> {

        const url = [
            this.thumbnailerUrl,
            accountId,
            fileId
        ].join('/');

        return this.getBearerToken()
            .take(1)
            .map(bearer => {
                let u = `${url}?bearer=${bearer}`;

                if (dims.width) {
                    u += `&width=${dims.width}`;
                }

                if (dims.height) {
                    u += `&height=${dims.height}`;
                }
                return u;
            });
    }

    protected getBearerToken(): Observable<string> {
        return this.store.select(state => state.config.authToken);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/remote-thumbnail.service.ts